import type { Entries } from './catalog';

/**
 * The copy of the consent an installed client on this computer needs before it is handed a product
 * session (`/consent`, the security review of 2026-10-17, M4): the product, the person it will act as,
 * and that an application on this computer will hold that product's session.
 *
 * Each area keeps its own file so its keys travel with its screens; a key here must not repeat one of
 * `en.ts`, `es.ts` or another area.
 */
export const consent: Record<'en' | 'es', Entries> = {
	en: {
		'consent.title': '{product} on this computer wants to sign in as {person}',
		'consent.title.unnamed': '{product} on this computer wants to sign in with your Beyond account',
		'consent.lead': 'This computer’s application will act in {product} with your access. Continue only if you started this sign-in.',
		'consent.address': 'The application is waiting at {address}.',
		'consent.continue': 'Continue',
		'consent.continuing': 'Continuing…',
		'consent.cancel': 'Cancel',
		'consent.reading': 'Reading the sign-in request…',
		'consent.gone': 'This sign-in request is no longer valid. Start signing in again from the application.',
		'consent.onward': 'Go to your overview',
		'consent.framed': 'This sign-in request can only be answered in a window of its own. Open the address in your browser.'
	},
	es: {
		'consent.title': '{product} en este equipo quiere iniciar sesión como {person}',
		'consent.title.unnamed': '{product} en este equipo quiere iniciar sesión con tu cuenta de Beyond',
		'consent.lead': 'La aplicación de este equipo actuará en {product} con tu acceso. Continúa solo si iniciaste este acceso.',
		'consent.address': 'La aplicación espera en {address}.',
		'consent.continue': 'Continuar',
		'consent.continuing': 'Continuando…',
		'consent.cancel': 'Cancelar',
		'consent.reading': 'Leyendo la solicitud de inicio de sesión…',
		'consent.gone': 'Esta solicitud de inicio de sesión ya no es válida. Vuelve a iniciar sesión desde la aplicación.',
		'consent.onward': 'Ir a tu resumen',
		'consent.framed': 'Esta solicitud de inicio de sesión solo se puede responder en una ventana propia. Abre la dirección en tu navegador.'
	}
};
